module.exports = __webpack_public_path__ + "img/[炸弹].a349d7cd.svg";